export default {
    record(id) {
        return this.transformer.one(
            this.try(
                this.baseQuery().include('translations').find(id)
            )
        );
    }
}
